/**
 * Feed Module Routes (PRD 2 — Story 2.4.3, consolidação E0.2.4).
 *
 * Rota canônica: ``/feed-global`` (decisão Augusto 2026-05-18, PRD E0 §5.3,
 * Opção B). Rotas antigas (``/feed``) redirecionam pro canônico via
 * ``<Navigate replace />`` — preserva back/forward do browser sem manter
 * a entrada na history.
 *
 * Permissão ``feed:read`` ainda não está seedada no DB (será introduzida
 * em story RBAC dedicada do PRD 2). Enquanto isso, o backend já gateia
 * com ``require_permissions(["feed:read"])`` e usuários sem a permissão
 * recebem 403; ``RequirePermission`` no frontend evita o request inútil.
 */

import { lazy } from "react";
import { Navigate } from "react-router-dom";

import { ModuleRoutes } from "../types";

const FeedPage = lazy(() => import("@/pages/feed/FeedPage"));

export const FEED_CANONICAL_PATH = "/feed-global";

export const feedRoutes: ModuleRoutes = {
  moduleId: "feed",
  basePath: FEED_CANONICAL_PATH,
  routes: [
    {
      path: FEED_CANONICAL_PATH,
      element: <FeedPage />,
      permission: { resource: "feed", action: "read" },
    },
    {
      // Legacy redirect — mantém links antigos / bookmarks funcionando.
      path: "/feed",
      element: <Navigate to={FEED_CANONICAL_PATH} replace />,
    },
  ],
};
